module.exports = __webpack_public_path__ + "static/media/icon-report-skill-star.94288273.svg";